export default function vendorsDirective() {
  return {
    template: require('./vendors.html'),
    scope: {
      functionVendors: '=',
      vendors: '=',
      isEdit: '<', // Pass-through, not used by vendors
    },
    controller: 'EMVendorsController',
    controllerAs: 'vendorsVM',
    bindToController: true,
    replace: true,
  };
}
